module.exports = __webpack_public_path__ + "static/media/9DESA15.6d8ab562.jpg";